/* eslint-disable */
export default {
  meetingTitle: 'Meeting van {extensionName}',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
